module.exports = __webpack_public_path__ + "media/images/no-image-3b7013265d45f609630b7f7a59bce2f2.jpg";